var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9625 1.66602H6.03751C5.07179 1.66602 4.58892 1.66602 4.19949 1.80152C3.46102 2.05848 2.88123 2.65534 2.63163 3.41557C2.5 3.81647 2.5 4.31356 2.5 5.30773V16.9778C2.5 17.693 3.32083 18.0725 3.84008 17.5974C4.14514 17.3182 4.60486 17.3182 4.90992 17.5974L5.3125 17.9657C5.84716 18.455 6.65284 18.455 7.1875 17.9657C7.72216 17.4765 8.52784 17.4765 9.0625 17.9657C9.59716 18.455 10.4028 18.455 10.9375 17.9657C11.4722 17.4765 12.2778 17.4765 12.8125 17.9657C13.3472 18.455 14.1528 18.455 14.6875 17.9657L15.0901 17.5974C15.3951 17.3182 15.8549 17.3182 16.1599 17.5974C16.6792 18.0725 17.5 17.693 17.5 16.9778V5.30773C17.5 4.31356 17.5 3.81647 17.3684 3.41557C17.1188 2.65534 16.539 2.05848 15.8005 1.80152C15.4111 1.66602 14.9282 1.66602 13.9625 1.66602Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 8.66602L9.10747 9.99935L12.0837 6.66602",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.916H13.75",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractCreate);
export default __webpack_public_path__ + "static/media/ContractCreate.b290b68a73771b59ab6f65f7d1fc2fea.svg";
export { ForwardRef as ReactComponent };